import uiActionTypes from '../action_types/ui-action-types'

const defaultState = {
	modalActive: null,
	popupTopActive: null,
	showModal: false,
	hideNavBar: false,
	showIconCloseModal: true,
	installPrompt: null,
	controllerBack: undefined,
	showSlideMenu: false,
	showLoading: false,
	showOverlay: {
		open: false,
		element: false,
		showIconBack: true
	}
}

const reducerObject = ({ state, payload = false }) => ({
	[uiActionTypes.setModal]: { ...state, modalActive: payload?.modalActive },
	[uiActionTypes.closeModal]: { ...state, modalActive: null },
	[uiActionTypes.setPopupTop]: { ...state, popupTopActive: payload?.popupTopActive },
	[uiActionTypes.closePopupTop]: { ...state, popupTopActive: null },
	[uiActionTypes.showLoading]: { ...state, showLoading: payload?.showLoading },
	[uiActionTypes.setInstallPrompt]: { ...state, installPrompt: payload?.installPrompt },
	[uiActionTypes.setControlBack]: { ...state, controllerBack: payload?.controllerBack },
	[uiActionTypes.showIconCloseModal]: { ...state, showIconCloseModal: payload.value },
	[uiActionTypes.resetControlBack]: { ...state, controllerBack: undefined },
	[uiActionTypes.toggleMenu]: { ...state, hideMenu: payload?.hideMenu },
	[uiActionTypes.toggleSliderMenu]: { ...state, showSlideMenu: !state.showSlideMenu },
	[uiActionTypes.openOverlay]: { ...state, showOverlay: payload?.showOverlay },
	[uiActionTypes.closeOverlay]: { ...state, showOverlay: defaultState.showOverlay },
	[uiActionTypes.handledNavBar]: { ...state, hideNavBar: payload?.hideNavBar }
})

const reducer = (state = defaultState, action) =>
	reducerObject({ state, payload: action.payload })[action.type] || state

export default reducer
